<template>
    <cmpTableWithMenu v-bind:name="name" 
        v-bind:pkColumn="pkColumn"
        v-bind:fields="fields" 
        v-bind:qryFields="qryFields" 
        v-bind:children="children"
        v-bind:parent="parent"
        v-bind:header="header"
        v-bind:tableFuncs="tableFuncs"
        v-bind:moreTableFuncs="moreTableFuncs"></cmpTableWithMenu>
</template>

<script>
    import cmpTableWithMenu from "@/components/common/cmpTableWithMenu"
    import i18n from '@/i18n'

    export default {
        components: {
            cmpTableWithMenu
        },
        computed: {
            fields() {
                return [
                    { "key": "Operation", "label": i18n.t('component.operation'), tdClass: 'text-center', thClass: 'text-center' },
                    { "key": "No", "label": "No." },
                    { "key": "UnitName", "label": i18n.t('component.Class.UnitName.label'), sortable: true },
                    { "key": "ClassName", "label": i18n.t('component.Class.ClassName.label'), sortable: true },
                    { "key": "ProjectCode", "label": i18n.t('component.Class.ProjectCode.label'), sortable: true }
                ]
            },
            qryFields() {
                return [
                    { "key": "ClassName", "label": i18n.t('component.Class.ClassName.label'), input: { type: "text" } },
                ]
            },
            header() {
                return i18n.t('component.Class.lstHeader')
            }
        },
        data() {
            return {
                name: "Class",
                pkColumn: "ClassId",
                parent: {},
                tableFuncs: ['rec', 'copyNew', 'edit', 'delete'],
                moreTableFuncs: [{ key: "BtnClassProjectParticipant", icon: "IcnAddpeople.png", tooltip: i18n.t('component.Class.ToolTip.ProjectParticipant'), function: { type: 'route', name: "lstProjectParticipant", key: "ProjectId" } }]

            };
        }
    }
</script>